<div class="h-100">
  <finx-button
    [labeltext]="renderedContent ?? 'continue'"
    class="pointer-events-none d-flex"
    [class]="globalStylingClass"
    [isAllowedGlobalStyling]="isAllowedGlobalStyling"
    (click)="pageAction()"
    [style.height]="'100%'"
    [buttonStyle]="!isAllowedGlobalStyling ? contentStyle : {}"
    [rightIconSize]="iconSize"
    [rightIcon]="icon"
    [type]="'button'"
  ></finx-button>
</div>
